// Import the necessary Firebase modules
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions , connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage";
// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB8_pwAb3tipMqejkmJKYbONCVwtBgnRAE",
  authDomain: "shoofmangmentapplcation.firebaseapp.com",
  projectId: "shoofmangmentapplcation",
  storageBucket: "shoofmangmentapplcation.appspot.com",
  messagingSenderId: "606306769569",
  appId: "1:606306769569:web:204569c837d003f4422ee0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

 const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app, "us-central1");
// Export Firestore instance
export { db, auth  , app, functions , storage};


// if (window.location.hostname === "localhost") {
//   connectFunctionsEmulator(functions, "127.0.0.1", 5001);
// }
